var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"ibox list-activity\"><div class=\"ibox-title\"><h5>Automation Center</h5></div><div class=\"ibox-content\"><uib-tabset><uib-tab heading=\"Automations Center\"><recipes-list></recipes-list></uib-tab><uib-tab heading=\"Automations\"><automations-list></automations-list></uib-tab></uib-tabset></div></div>";
var id1="automations-center.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;